import React, { Component } from "react";
import PropTypes from "prop-types";
import { Translate as T } from "react-redux-i18n";
import styles from "./Prizes.css";
import PrizeContainer from "./PrizeContainer";
import PirateContainer from "../Pirate/PirateContainer";
import Overlay from "../Overlay/Overlay";
import HeadingPaper from "../HeadingPaper/HeadingPaper";

export default class Prizes extends Component {
  static defaultProps = {
    show: false,
    ids: []
  };

  static propTypes = {
    show: PropTypes.bool,
    ids: PropTypes.array,
    savePrizePositions: PropTypes.func,
    hidePrizes: PropTypes.func
  };

  render = () => (
    <Overlay show={this.props.show}>
      <div className={styles.heading}>
        <HeadingPaper>
          <h1>
            <T value={"prizes.heading"} />
          </h1>
        </HeadingPaper>
      </div>
      {this.props.ids.map(id => (
        <PrizeContainer key={id} id={id} />
      ))}
      <PirateContainer />
      <button onClick={this.handleCloseClick} className={styles.close}>
        <T value="common.close" />
      </button>
    </Overlay>
  );

  handleCloseClick = () => {
    this.props.savePrizePositions();
    this.props.hidePrizes();
  };
}



// WEBPACK FOOTER //
// ./src/components/Prizes/Prizes.js